export default function BusinessDevelopmentIcon({ width = 16, height = 16, ...props }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={width} height={height} viewBox='0 0 16 15' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M5.42857 2C5.42857 1.84221 5.55649 1.71429 5.71429 1.71429H10.2857C10.4435 1.71429 10.5714 1.84221 10.5714 2V3.42857H5.42857V2ZM3.71429 3.42857V2C3.71429 0.895429 4.60971 0 5.71429 0H10.2857C11.3903 0 12.2857 0.895429 12.2857 2V3.42857H14.2857C15.2325 3.42857 16 4.19608 16 5.14286V7.28571H0V5.14286C0 4.19608 0.767512 3.42857 1.71429 3.42857H3.71429ZM0 13.1429V8.71429H3.85714V9.71429C3.85714 10.1088 4.17694 10.4286 4.57143 10.4286C4.96592 10.4286 5.28571 10.1088 5.28571 9.71429V8.71429H10.7143V9.71429C10.7143 10.1088 11.0341 10.4286 11.4286 10.4286C11.8231 10.4286 12.1429 10.1088 12.1429 9.71429V8.71429H16V13.1429C16 14.0896 15.2325 14.8571 14.2857 14.8571H1.71429C0.767512 14.8571 0 14.0896 0 13.1429Z'
        fill='currentColor'
      />
    </svg>
  );
}
